<template>
  <div>
    <el-dialog
        title="实名认证"
        :visible.sync="showDialog"
        :width=dialogWidth
        :before-close="closeDialog"
        center>
      <div>
        <div>
          <p>应国家《关于防止未成年人沉迷网络游戏的通知》要求，账号必须实名认证方能进入游戏，否则无法游戏。</p>
        </div>
        <el-form :model="realNameForm" label-width="70px" class="demo-ruleForm" size="mini" :rules="realNameRule"
                 ref="realNameForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="realNameForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="证件号" prop="number">
            <el-input v-model="realNameForm.number" class="code_input" placeholder="请输入证件号"></el-input>
          </el-form-item>
          <el-button size="mini" type="warning" @click="handleSubmit('realNameForm')" class="bind_btn">提交</el-button>
          <div class="placehold"></div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ScreenMixins from '@/mixins/ScreenMixins';
import Message from '@/mixins/Message';
import {txPostRequest} from "@/plugins/request";

export default {
  name: 'RealName',
  props: ['show'],
  mixins: [ScreenMixins, Message],
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入姓名'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      const numberRegex = /^\d{17}[\dXx]$/i;
      if (value === '') {
        callback(new Error('请输入身份证号码'));
      } else if (!numberRegex.test(value)) {
        callback(new Error('无效的身份证号码'));
      } else {
        callback();
      }
    };
    return {
      dialogWidth: "50%",
      real_success:false,
      realNameForm: {
        name: '',
        number: '',
      },
      realNameRule: {
        phone: [
          {validator: validatePhone, trigger: 'blur'}
        ],
        code: [
          {validator: validateCode, trigger: 'blur'}
        ]
      },
    };
  },
  computed: {
    showDialog() {
      return this.handleDialog()
    }
  },
  methods: {
    handleSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let {code,message,data} =await txPostRequest('/user/idcard_auth', {
            real_name: this.realNameForm.name,
            id_card: this.realNameForm.number
          })
          if (code!==0){
            return this.errorMessage(message)
          }
          this.successMessage('实名成功')
          let user_params=JSON.parse(localStorage.getItem('userInfo'))
          let info=JSON.stringify({...user_params,real_name:data.real_name})
          localStorage.setItem("userInfo", info)
          this.real_success=true
          this.$refs[formName].resetFields();
          this.closeDialog()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeDialog() {
      this.$emit('child-real', false, this.real_success);
      this.realNameForm = {
        name: '',
        number: '',
      }
    },
    handleDialog() {
      this.updateDialogWidth();
      window.addEventListener('resize', this.updateDialogWidth);
      return !!this.show
    },
  },

  mounted() {
  }
};
</script>

<style scoped>
.bind_btn {
  position: absolute;
  left: 42%;
  margin-bottom: 24px;
}

.placehold {
  margin: 150px 0;
}

.el-dialog__wrapper >>> .el-dialog__body {
  display: flex;
  justify-content: center;
}
</style>
